module.exports = __webpack_public_path__ + "img/banner-2-3.4b8d3cc9.png";